import { IPlanType } from "../types";
import { firebase } from "../config/firebase.client";
import { onValue, update, remove, push } from "firebase/database";
import { PLANS_ADD, PLANS_EDIT, PLANS_FETCH, PLANS_ERROR, PLANS_REMOVE } from "../store/types";

export const fetchPlans = () => async (dispatch: any) => {
    const { plansRef } = firebase;
    try {

        const snapshot: any = await new Promise((resolve, reject) => {
            onValue(plansRef, (snapshot) => {
                resolve(snapshot);
            }, {
                onlyOnce: true
            });
        });

        if (snapshot.exists()) {
            const plansData = snapshot.val();

            const plansArray = Object.keys(plansData).map((key) => ({
                ...plansData[key],
                ref: key,
            }));

            plansArray.sort((a, b) => b.createdAt - a.createdAt);


            dispatch({
                type: PLANS_FETCH,
                payload: plansArray,
            });
        } else {
            throw new Error('Document not found');
        }
    } catch (error: any) {
        console.error('Error fetching plans data:', error);
        dispatch({
            type: PLANS_ERROR,
            payload: error.message,
        });
    }
};

export const editPlans = (plans: IPlanType, method: "Add" | "Delete" | "Update") => async (dispatch: any) => {
    const { plansAddRef, plansEditRef } = firebase;

    if (method === "Add") {
        const newAdRef = push(plansAddRef, plans);;
        const newAdData = { ...plans, ref: newAdRef.key };
        dispatch({
            type: PLANS_ADD,
            payload: newAdData,
        });
    }
    else if (method === "Delete") {
        remove(plansEditRef(plans.ref));

        dispatch({
            type: PLANS_REMOVE,
            payload: plans,
        });
    }
    else if (method === "Update") {
        update(plansEditRef(plans.ref), plans);

        dispatch({
            type: PLANS_EDIT,
            payload: plans,
        });
    }
};